import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { PortalModule } from './portal/portal.module';

// Comes from mode.js
if (window['__env'].production) {
  enableProdMode();
}
const path = window.location.pathname;

if (path.startsWith('/portal')) {
  platformBrowser()
    .bootstrapModule(PortalModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => console.error(err));
} else {
  platformBrowser()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => console.error(err));
}
